
export default{
    data: () => ({
        slug: ''
    }),
    created(){
        this.slug = this.$route.params.slug
    }
}